/* eslint-disable react/style-prop-object */
import styled from "styled-components";
import Modal from "../../../components/Modal/Modal";
import { useApp } from "../../../contexts";

const ContentWaper = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;


export const ModalFeatureNotAvailable = ({ onClose, onSubmit }) => {
  const { T } = useApp();

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2/>
      <Modal.Container2
        width="600px"
        className={"modal-mint"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className="text-[#F12E11] text-center font-semibold text-[24px] xls:text-[30px] tracking-[-0.96px] lg:h-full">
            {T("Feature Not Available")}
          </div>
          <div className="mt-[10px] lg:mt-[10px] overflow-y-auto max-h-[50vh]">
            <div>
              <div className="mt-[20px] text-[14px] md:text-[16px] lg:mt-[20px] text-center justify-center items-center text-[#6B6B6B] text-base leading-[26px]"
              >
                {T('This feature is not applicable to your account. If you believe this is a mistake, please contact support.')}
              </div>
              <div className="flex gap-3 md:gap-[20px] justify-center flex-col md:flex-row items-center mt-[40px]">
                <button
                  onClick={() => onSubmit()}
                  className="rounded-[14px] border border-solid px-[16px] py-[9px] min-w-[150px] w-full sm:w-auto bg-black text-[#fff] text-center text-[14px] md:text-[16px]"
                >
                  {T("OK")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
